import { ParsedReportParams } from '@ais-ui/websockets';
import { ShapeType } from '../../reportsTypes';
import { safeJsonParse } from './safeJsonParse';

export const findShapeTypeFromReport = (
  report: ParsedReportParams | undefined,
): ShapeType => {
  if (report?.params['WS'] === 1) {
    return 'worldShape';
  }
  if (report?.params['GAC']) {
    const givenShape = report?.params['GAC']?.shape
      ? safeJsonParse(
          report.params['GAC'].shape,
          null,
          'findShapeTypeFromReport',
        )
      : null;

    if (!givenShape) {
      return 'shape';
    } else if (givenShape.type !== 'FeatureCollection') {
      return 'shape';
    } else {
      return 'multiShape';
    }
  } else if (report?.params['PORT'] && report?.params['PORT'].length > 0) {
    const givenPorts = Array.isArray(report?.params['PORT'])
      ? report?.params['PORT']
      : [];
    if (givenPorts.length > 0) {
      return 'ports';
    }
  } else {
    return 'shape';
  }

  return 'shape';
};

export const findShapeTypeFromKeyTrips = (
  report: ParsedReportParams | undefined,
  firstKey: string,
  secondKey = 'GAC', // Normally GAC, but can vary based on report type, see for example trips
): ShapeType | null => {
  const shapeValue = report?.params?.[firstKey]?.[secondKey]?.shape;
  const givenShape = shapeValue
    ? safeJsonParse(shapeValue, null, 'findShapeTypeFromKeyTrips')
    : null;

  if (!givenShape) {
    return null;
  } else if (givenShape.type !== 'FeatureCollection') {
    return 'shape';
  } else {
    return 'multiShape';
  }
};
